import RegisterPage from './RegisterPage.jsx';

export default RegisterPage;